import { jsx } from "react/jsx-runtime";
import Skeleton__default from "antd/es/skeleton";
import classnames from "../../utils/classnames.js";
const DealerInfoButtonsSkeleton = ({ className, active }) => {
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-buttons", className), children: /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-buttons__skeleton"), children: /* @__PURE__ */ jsx(
    Skeleton__default.Button,
    {
      block: true,
      active,
      size: "default",
      className: classnames("perxis-auto-dealer-info-buttons__skeleton-button")
    }
  ) }) });
};
export {
  DealerInfoButtonsSkeleton as default
};
//# sourceMappingURL=DealerInfoButtonsSkeleton.js.map
